import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import EqualHeightComponent from '@bbkPricingPage/components/equal-height-component/equal-height-component';
import { getFormattedAmount } from '@bbkPricingPage/lib/currencies';

interface PriceBreakdownProps {
  showPriceBreakdown: boolean;
  mandatoryAddonsPriceValue: number;
  chargeValue: number;
  planPriceValue: number;
  currency: string;
  ignoreEqualHeight?: boolean;
}

export const PriceBreakdown: React.FC<PriceBreakdownProps> = ({
  showPriceBreakdown,
  planPriceValue,
  mandatoryAddonsPriceValue,
  chargeValue,
  currency,
  ignoreEqualHeight,
}) => {
  const shouldShow =
    showPriceBreakdown &&
    planPriceValue != null &&
    planPriceValue != undefined &&
    currency &&
    (mandatoryAddonsPriceValue || chargeValue);

  return (
    <EqualHeightComponent
      groupId="dynamic-height-pricing-card-price-breakdown"
      ignore={ignoreEqualHeight}
    >
      {shouldShow ? (
        <div className="tw-mt-0">
          <div
            className={cs(
              'tw-p-1 tw-text-center tw-text-xs tw-text-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_60%,transparent)]'
            )}
          >
            {planPriceValue !== null && (
              <>{getFormattedAmount(planPriceValue, currency)} plan</>
            )}
            {mandatoryAddonsPriceValue > 0 && (
              <>
                {' + '}
                {getFormattedAmount(mandatoryAddonsPriceValue, currency)} addon
              </>
            )}
            {chargeValue > 0 && (
              <>
                {' + '}
                {getFormattedAmount(chargeValue, currency)} one-time addon
              </>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </EqualHeightComponent>
  );
};
